import axios from 'axios'
// import storage from '../storage'
import config from '../../config'

export
const storage = {
  getToken() {
    return localStorage.bzToken;
  },
  setToken(token) {
    localStorage.bzToken = token;
  },
  getPayload() {
    if (!localStorage.bzToken) {
      return null;
    }
    const [, payload] = localStorage.bzToken.split('.');
    try {
      return JSON.parse(atob(payload));
    } catch (err) {
      return null;
    }
  }
};

const configure = axios => {
  axios.defaults.baseURL = config.getApiUrl();

  axios.interceptors.request.use(config => {
    config.headers.authorization = storage.getToken();
    return config;
  });

  axios.interceptors.response.use(
    response => {
      const { authorization } = response.headers;
      if (authorization) {
        storage.setToken(authorization)
      }
      return response;
    },
    error => {
      if (error.response.status === 401) {
        return new Promise((resolve, reject) => {
          storage.setToken('');
          return reject(error.response.data);
        })
      }
      return new Promise((resolve, reject) => reject(error.response.data));
    }
  );
  return axios;
}

export default configure(axios)



// WEBPACK FOOTER //
// ./client/store/my-axios.js